<h1>{{title}}</h1>
<ul class="list-ic vertical">
  <li *ngFor="let item of list">
    <span>{{ item.order }}</span>
    <a>{{ item.label }}</a>
  </li>
</ul>
